import React, {useState} from 'react'
import { useNavigate } from 'react-router-dom'
//import styles
import style from './a.module.scss'
//import components
import BackButton from '../../components/BackButton/BackButton'
import TextBox from '../../components/TextBox/TextBox'
import PrimaryButton from '../../components/PrimaryButton/PrimaryButton'
//import assets
import emailIcon from '../../assets/icons/material-symbols_mail.svg'

const ForgetPassword = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('')

  return (
    <div className={style.forgetPassword}>
        <div className={style.backbtn} onClick={() => navigate(-1)}>
            <BackButton />
        </div>
        <div className={style.forgetPasswordFields}>
            <h1>Forgot Password</h1>
            <div className={style.inputBox}>
                <TextBox type="email" placeholder="Email" icon={emailIcon} value={email} onChange={(e) => setEmail(e.target.value)} inputBox={true}/>
            </div>
        </div>
        <div className={style.sendLinkBtn}>
            <PrimaryButton title='Send Reset Link' />
        </div>
    </div>
  )
}

export default ForgetPassword